module.exports = __webpack_public_path__ + "img/chevron-up.a3cd4a9b.svg";